export class SejourSummary {
    constructor(gformSejour) {
        this.gform = gformSejour;
        this.wrapper = gformSejour.formWrapper;
    }

    update() {
        this.updateParticipants();
        this.updateAccommodation();
        this.updatePensions();
        this.updateTransfer();
        this.updateTotals();
    }

    updateParticipants() {
        const items = this.wrapper.querySelectorAll('[data-summary="participants"]');
        const { participants } = this.gform.state;
        const unitPrice = this.gform.prices.participant;
        const price = participants * unitPrice;

        items.forEach(item => {
            const countEl = item.querySelector('[data-count]');
            const detailEl = item.querySelector('[data-detail]');
            const valueEl = item.querySelector('[data-value]');

            if (countEl) countEl.textContent = participants;
            if (detailEl) detailEl.textContent = `${participants} x ${this.gform.formatPrice(unitPrice)}`;
            if (valueEl) valueEl.textContent = this.gform.formatPrice(price);
        });
    }

    updateAccommodation() {
        const items = this.wrapper.querySelectorAll('[data-summary="accommodation"]');
        const { accommodation, accommodationPrice } = this.gform.state;

        items.forEach(item => {
            if (accommodation && accommodation !== 'Aucun') {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const nameEl = item.querySelector('[data-name]');
                const valueEl = item.querySelector('[data-value]');
                if (nameEl) nameEl.textContent = accommodation;
                if (valueEl) valueEl.textContent = accommodationPrice > 0 ? this.gform.formatPrice(accommodationPrice) : 'Inclus';
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updatePensions() {
        const adultItems = this.wrapper.querySelectorAll('[data-summary="pension-adult"]');
        const childItems = this.wrapper.querySelectorAll('[data-summary="pension-child"]');
        const { adultPensions, childPensions } = this.gform.state;
        const { adultPension: priceAdultPension, childPension: priceChildPension } = this.gform.prices;

        adultItems.forEach(item => {
            if (adultPensions > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (detailEl) detailEl.textContent = `${adultPensions} x ${this.gform.formatPrice(priceAdultPension)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(adultPensions * priceAdultPension);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });

        childItems.forEach(item => {
            if (childPensions > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (detailEl) detailEl.textContent = `${childPensions} x ${this.gform.formatPrice(priceChildPension)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(childPensions * priceChildPension);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updateTransfer() {
        const items = this.wrapper.querySelectorAll('[data-summary="transfer"]');
        const { transferCount } = this.gform.state;
        const transferPrice = this.gform.prices.transfer;
        const totalTransfer = transferCount * transferPrice;

        items.forEach(item => {
            if (transferCount > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');
                if (detailEl) detailEl.textContent = `${transferCount} x ${this.gform.formatPrice(transferPrice)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(totalTransfer);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updateTotals() {
        const total = this.gform.calculateTotal();
        const deposit = this.gform.calculateDeposit();

        const totalEls = this.wrapper.querySelectorAll('[data-total]');
        const depositEls = this.wrapper.querySelectorAll('[data-deposit]');

        totalEls.forEach(el => {
            el.textContent = this.gform.formatPrice(total);
        });

        depositEls.forEach(el => {
            el.textContent = this.gform.formatPrice(deposit);
        });
    }
}
